import { Button, Layout } from "antd";
import styled from "styled-components";

export const StyledTotalSum = styled.div`
    width: 100%;
    padding: 4px 16px;
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
    font-size: 12px;
    line-height: 20px;
`;

export const StyledTotalSumTitle = styled.p`
    font-weight: 700;
`;

export const StyledUpdateRemainingWarning = styled.div`
    height: 100px;
    width: 100%;
    padding: 10px 16px;
    background-color: rgba(43, 33, 17, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 1;
    gap: 12px;
    border: 1px solid rgba(255, 215, 5, 0.1);
`;

export const StyledUpdateRemainingWarningText = styled.p`
    font-size: 12px;
    line-height: 140%;
    color: ${(props) => props.theme.colors.white};
`;

export const StyledUpdateInventoryBtn = styled(Button)`
    background-color: ${(props) => props.theme.colors.warning};
    height: 32px;
    width: 100%;
`;

export const SearchWrapper = styled(Layout)`
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 16px;
    align-items: center;
    flex-direction: row;
    .ant-input::placeholder {
        color: ${(props) => props.theme.secondaryTypographyColor};
    }
    .ant-select-selection-placeholder {
        color: ${(props) => props.theme.secondaryTypographyColor};
    }
`;
